import Indicador from "..";
import NGVEditFields from "./components/NGVEditFields";
import { NGVParamFields } from "./components/NGVParamFields";
import ngvReport from "./reports";
import ngvReportSummary from "./reports/summary";
import _ from 'lodash'

export default class NGV extends Indicador {
    static get fullName() {
        return "Número de Gemas Viáveis";
    }

    static get abbrev() {
        return "NGV";
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraNGV: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            seletorImplementoNGV: "implemento",
            frente: "frente",
            turno: "turno",

            insumo: "insumo",
            totalGemas: "totalGemas",
            total: "total",

            coletasNGV: {
                type: Array,
                newField: "coletas",
                children: {
                    qtdGemas: "qtdGemas",
                    qtdGemasMetro: "qtdGemasMetro",
                    danosPragasClima: "danosPragasClima",
                    danosMecanico: "danosMecanico",
                    conforme: "conforme",
                    observacao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostraNGV: "observacao",

            itensColetaNGV: "images",
        };
    }

    static get legacyParamMap() {
        return {
            GVMinimoManual: "manual.intervaloMin",
            GVMaximoManual: "manual.intervaloMax",
            metroPontoAvaliadoManual: "manual.metroPontoAvaliado",
            valorMetaNGVManual: "manual.meta",

            GVMinimoMecanizado: "mecanizado.intervaloMin",
            GVMaximoMecanizado: "mecanizado.intervaloMax",
            metroPontoAvaliadoMecanizado: "mecanizado.metroPontoAvaliado",
            valorMetaNGVMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <NGVParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    // TODO: (b_2089) 3º
    presetPontosAmostrados(form) {
        let values = form.getValues()
        if (values.params.ngv.mecanizado) {
            if (values.params.ngv.mecanizado.intervaloMin && values.params.ngv.mecanizado.intervaloMax) {
                form.api.change('params.ngv.items[0].classificacao', "Abaixo")
                form.api.change('params.ngv.items[0].sinalIntervaloMin', ">=")
                form.api.change('params.ngv.items[0].intervaloMin', "0")
                form.api.change('params.ngv.items[0].sinalIntervaloMax', "<")
                form.api.change('params.ngv.items[0].intervaloMax', values.params.ngv.mecanizado.intervaloMin)

                form.api.change('params.ngv.items[1].classificacao', "Boa")
                form.api.change('params.ngv.items[1].sinalIntervaloMin', ">=")
                form.api.change('params.ngv.items[1].intervaloMin', values.params.ngv.mecanizado.intervaloMin)
                form.api.change('params.ngv.items[1].sinalIntervaloMax', "<=")
                form.api.change('params.ngv.items[1].intervaloMax', values.params.ngv.mecanizado.intervaloMax)

                form.api.change('params.ngv.items[2].classificacao', "Acima")
                form.api.change('params.ngv.items[2].sinalIntervaloMin', ">")
                form.api.change('params.ngv.items[2].intervaloMin', values.params.ngv.mecanizado.intervaloMax)
                // form.api.change('params.ngv.items[2].sinalIntervaloMax', "<")
                // form.api.change('params.ngv.items[2].intervaloMax', String(parseFloat(values.params.ngv.mecanizado.intervaloMax) * 1.3))
            }
        } else if (values.params.ngv.manual) {
            if (values.params.ngv.manual.intervaloMin && values.params.ngv.manual.intervaloMax) {
                form.api.change('params.ngv.items[0].classificacao', "Abaixo")
                form.api.change('params.ngv.items[0].sinalIntervaloMin', ">=")
                form.api.change('params.ngv.items[0].intervaloMin', "0")
                form.api.change('params.ngv.items[0].sinalIntervaloMax', "<")
                form.api.change('params.ngv.items[0].intervaloMax', values.params.ngv.manual.intervaloMin)

                form.api.change('params.ngv.items[1].classificacao', "Boa")
                form.api.change('params.ngv.items[1].sinalIntervaloMin', ">=")
                form.api.change('params.ngv.items[1].intervaloMin', values.params.ngv.manual.intervaloMin)
                form.api.change('params.ngv.items[1].sinalIntervaloMax', "<=")
                form.api.change('params.ngv.items[1].intervaloMax', values.params.ngv.manual.intervaloMax)

                form.api.change('params.ngv.items[2].classificacao', "Acima")
                form.api.change('params.ngv.items[2].sinalIntervaloMin', ">")
                form.api.change('params.ngv.items[2].intervaloMin', values.params.ngv.manual.intervaloMax)
                // form.api.change('params.ngv.items[2].sinalIntervaloMax', "<")
                // form.api.change('params.ngv.items[2].intervaloMax', String(parseFloat(values.params.ngv.manual.intervaloMax) * 1.3))
            }
        }
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <NGVEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return ngvReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ngvReportSummary(this, visita, tipoName);
    }

    getAverage(visita, field, tipoName, params) { // pdf da visita ou pdf do laudo
        const apontamentos = visita.getApontamentosByIndicador(this, tipoName);

        if (!_.isEmpty(apontamentos)) {
            if (field === "conformidade") {
                let qtdConforme = 0
                let qtdNaoConforme = 0

                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        if (coleta.conforme === "Sim") {
                            qtdConforme++
                        } else {
                            qtdNaoConforme++
                        }
                    }
                })

                return (qtdConforme * 100) / (qtdConforme + qtdNaoConforme)
            } else if (field === "arrowNaoConforme") {
                let numAcima = 0, numAbaixo = 0
                let sumAcima = 0, sumAbaixo = 0
                let avgAcima = 0, avgAbaixo = 0
                let percentAcima = 0, percentAbaixo = 0
                let numConforme = 0
                let obj

                apontamentos.forEach(apontamento => {
                    if ( // cálculo já foi feito no cadastro do apontamento
                        apontamento.hasOwnProperty('sumAbaixo')
                        && apontamento.hasOwnProperty('sumAcima')
                        && apontamento.hasOwnProperty('qtdAbaixo')
                        && apontamento.hasOwnProperty('qtdAcima')
                    ) {
                        numAcima += apontamento.qtdAcima
                        numAbaixo += apontamento.qtdAbaixo
                        sumAcima += apontamento.sumAcima
                        sumAbaixo += apontamento.sumAbaixo
                        numConforme += apontamento.qtdConforme
                    } else {
                        const f = parseFloat
                        let qtdAcima = 0
                        let qtdAbaixo = 0
                        let sumGemasMetroAcima = 0
                        let sumGemasMetroAbaixo = 0

                        for (const coleta of apontamento.coletas) {
                            if (coleta.conforme === "Não") {
                                if (f(coleta.qtdGemasMetro) < f(params.intervaloMin)) {
                                    qtdAbaixo++
                                    sumGemasMetroAbaixo += f(coleta.qtdGemasMetro)
                                } else if (f(coleta.qtdGemasMetro) > f(params.intervaloMax)) {
                                    qtdAcima++
                                    sumGemasMetroAcima += f(coleta.qtdGemasMetro)
                                }
                            } else if (coleta.conforme === "Sim") {
                                numConforme++
                            }
                        }

                        if (qtdAcima > 0) {
                            numAcima += qtdAcima
                            sumAcima += sumGemasMetroAcima
                        }
                        if (qtdAbaixo > 0) {
                            numAbaixo += qtdAbaixo
                            sumAbaixo += sumGemasMetroAbaixo
                        }
                    }
                })

                if (numAcima > 0) {
                    percentAcima = (numAcima * 100) / (numConforme + numAcima + numAbaixo)
                    avgAcima = ((sumAcima / numAcima).toFixed(3))
                } else { avgAcima = 0 }

                if (numAbaixo > 0) {
                    percentAbaixo = (numAbaixo * 100) / (numConforme + numAcima + numAbaixo)
                    avgAbaixo = (((sumAbaixo / numAbaixo)).toFixed(3))
                } else { avgAbaixo = 0 }

                obj = {
                    result: "igual",
                    acima: avgAcima,
                    abaixo: avgAbaixo,
                    qtdAcima: numAcima,
                    qtdAbaixo: numAbaixo,
                    sumAcima: sumAcima,
                    sumAbaixo: sumAbaixo,
                    percentAcima: percentAcima,
                    percentAbaixo: percentAbaixo,
                }
                return obj
            }
        }
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;
        let sumGemas = 0
        let sumDanosPragasClima = 0
        let sumDanosMecanico = 0

        // nº de gemasMetro abaixo da meta
        let qtdAbaixo = 0
        let sumGemasMetroAbaixo = 0

        // nº de gemasMetro acima da meta
        let qtdAcima = 0
        let sumGemasMetroAcima = 0

        for (const coleta of apontamento.coletas) {
            if (coleta.qtdGemas && params.metroPontoAvaliado) {
                coleta.qtdGemasMetro = f(coleta.qtdGemas) / f(params.metroPontoAvaliado);
                coleta.qtdGemasMetro = f(coleta.qtdGemasMetro).toFixed(2);
            } else {
                coleta.qtdGemasMetro = "0";
            }

            if (
                f(coleta.qtdGemasMetro) >= f(params.intervaloMin) &&
                f(coleta.qtdGemasMetro) <= f(params.intervaloMax)
            ) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não";
                if (f(coleta.qtdGemasMetro) < f(params.intervaloMin)) {
                    coleta.acima = 0
                    coleta.abaixo = 1
                    qtdAbaixo++
                    sumGemasMetroAbaixo += f(coleta.qtdGemasMetro)
                } else if (f(coleta.qtdGemasMetro) > f(params.intervaloMax)) {
                    coleta.acima = 1
                    coleta.abaixo = 0
                    qtdAcima++
                    sumGemasMetroAcima += f(coleta.qtdGemasMetro)
                }
            }

            sumGemas = sumGemas + f(coleta.qtdGemas || 0)
            sumDanosPragasClima = sumDanosPragasClima + f(coleta.danosPragasClima || 0)
            sumDanosMecanico = sumDanosMecanico + f(coleta.danosMecanico || 0)
        }

        apontamento.qtdAcima = qtdAcima
        // nao da pra fazer divisao por zero
        if (qtdAcima > 0) {
            apontamento.percentAcima = (qtdAcima * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAcima = (sumGemasMetroAcima / qtdAcima) // média de gemas por metro e qtd de cada ponto fora da meta
            apontamento.sumAcima = f(sumGemasMetroAcima)
        } else { apontamento.mediaAcima = 0 }

        apontamento.qtdAbaixo = qtdAbaixo
        if (qtdAbaixo > 0) {
            apontamento.percentAbaixo = (qtdAbaixo * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAbaixo = (sumGemasMetroAbaixo / qtdAbaixo)
            apontamento.sumAbaixo = f(sumGemasMetroAbaixo)
        } else { apontamento.mediaAcima = 0 }

        apontamento.qtdConforme = conformeCount
        apontamento.totalGemas = sumGemas
        apontamento.total = sumGemas + sumDanosPragasClima + sumDanosMecanico

        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 88.89, 100, 105.55);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.qtdGemas)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Faz.", field: "laudoRef.fazenda.nomeFazenda" },
            // { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Turno", field: "turno", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            { title: "Variedade", field: "insumo", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                // title: "Inviáveis", width: 'auto', getValue: (a) => {
                title: "Inv.", width: 'auto', getValue: (a) => {
                    let sum = 0
                    a.coletas.forEach(x => {
                        if (x.qtdGemas) {
                            if (x.conforme !== "Sim")
                                sum = sum + parseFloat(x.qtdGemas)
                        }

                    })
                    if (sum) {
                        return sum
                    } else {
                        return '0'
                    }
                }
            },
            {
                title: "Viáveis", width: 'auto', getValue: (a) => {
                    let sum = 0
                    a.coletas.forEach(x => {
                        if (x.qtdGemas) {
                            if (x.conforme === "Sim")
                                sum = sum + parseFloat(x.qtdGemas)
                        }

                    })
                    if (sum) {
                        return sum
                    } else {
                        return '0'
                    }

                }
            },
            { title: "Total Gemas", field: "totalGemas", width: 'auto' },
            // { title: "T. Gemas", field: "totalGemas", width: 'auto' },
            {
                title: "Danos Pragas/Clima", width: 'auto', getValue: (a) => {
                    // sumDanosPragasClima = sumDanosPragasClima + parseFloat(coleta.danosPragasClima || 0)
                    // sumDanosMecanico = sumDanosMecanico + parseFloat(coleta.danosMecanico || 0)
                    let sumDanosPragasClima = 0

                    a.coletas.forEach(c => {
                        if (c.danosPragasClima) {
                            sumDanosPragasClima = sumDanosPragasClima + parseFloat(c.danosPragasClima)
                        }
                    })

                    if (sumDanosPragasClima) {
                        return sumDanosPragasClima
                    } else {
                        return '0'
                    }

                }
            },
            {
                // title: "Danos Mecanico", width: 'auto', getValue: (a) => {
                title: "Danos Mec.", width: 'auto', getValue: (a) => {
                    let sumDanosMecanico = 0

                    a.coletas.forEach(c => {
                        if (c.danosMecanico) {
                            sumDanosMecanico = sumDanosMecanico + parseFloat(c.danosMecanico)
                        }
                    })

                    if (sumDanosMecanico) {
                        return sumDanosMecanico
                    } else {
                        return '0'
                    }

                }
            },
            { title: "Total", field: "total", width: 'auto' },
            {
                title: "Gemas/M", width: 'auto', getValue: (a) => {
                    let sum = 0
                    let arr = a.coletas.map(x => {
                        if (x.qtdGemasMetro) {
                            sum = sum + parseFloat(x.qtdGemasMetro)
                            return x.qtdGemasMetro
                        } else {
                            return 0
                        }

                    })
                    if (sum) {
                        return (sum / arr.length).toFixed(2)
                    } else {
                        return '0'
                    }
                }
            },
            {
                // title: "Inviáveis (%)", width: 'auto', getValue: (a) => {
                title: "Inv. (%)", width: 'auto', getValue: (a) => {
                    let sumIn = 0
                    let sumTotal = 0
                    a.coletas.forEach(x => {
                        if (x.qtdGemas) {
                            sumTotal = sumTotal + parseFloat(x.qtdGemas)
                            if (x.conforme !== "Sim")
                                sumIn = sumIn + parseFloat(x.qtdGemas)
                        }

                    })
                    if (sumIn) {
                        return (sumIn / sumTotal * 100).toFixed(2)
                    } else {
                        return '0'
                    }

                }
            },

            {
                // title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                title: "Conf.(%)", field: "conformidade", width: "auto", getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        let sumInv = 0
        let sumVi = 0
        let sumTotal = 0
        let sumDanosPragasClima = 0
        let sumDanosMecanico = 0
        let arrGemasMetro = [], sumGemasMetro = 0, gemasMetro = 0
        let invPercent = 0

        apontamento.coletas?.forEach(x => {
            if (x.qtdGemas) {
                sumTotal = sumTotal + parseFloat(x.qtdGemas)
                if (x.conforme !== "Sim")
                    sumInv = sumInv + parseFloat(x.qtdGemas)
                if (x.conforme === "Sim")
                    sumVi = sumVi + parseFloat(x.qtdGemas)
            }
            if (x.danosPragasClima) {
                sumDanosPragasClima = sumDanosPragasClima + parseFloat(x.danosPragasClima)
            }
            if (x.danosMecanico) {
                sumDanosMecanico = sumDanosMecanico + parseFloat(x.danosMecanico)
            }
            if (x.qtdGemasMetro) {
                sumGemasMetro = sumGemasMetro + parseFloat(x.qtdGemasMetro)
                arrGemasMetro.push(x.qtdGemasMetro)
            } else {
                arrGemasMetro.push(0)
            }
        })

        if (sumGemasMetro) {
            gemasMetro = (sumGemasMetro / arrGemasMetro.length).toFixed(2)
        } else {
            gemasMetro = '0'
        }

        if (sumInv) {
            invPercent = (sumInv / sumTotal * 100).toFixed(2)
        } else {
            invPercent = '0'
        }

        return "Inviáveis: " + sumInv +
            ", Viáveis: " + sumVi +
            ", Total Gemas: " + apontamento.totalGemas +
            ", Danos Pragas/Clima: " + sumDanosPragasClima +
            ", Danos Mecanico: " + sumDanosMecanico +
            ", Total: " + apontamento.total +
            ", Gemas/M: " + gemasMetro +
            " e Inviáveis (%): " + invPercent
    }
}
